import React from 'react'
import { Empty as EmptyAnt } from 'antd'

import { T } from '..'

function Empty() {
  return (
    <EmptyAnt
      description={T({ text: 'common.no-data' })}
      image={EmptyAnt.PRESENTED_IMAGE_SIMPLE}
    />
  )
}

export default Empty
